import React from "react";
import { Grid, TextField, Box, Divider, Tooltip } from "@mui/material";
import Chip from "@mui/material/Chip";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { Alert, AlertTitle } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import SearchField from "react-search-field";

export default function Applications(props) {
  let { OSTYPE, appsetFormFields, appfieldIndex, setNormalport } = props;
  const [customapps, setCustomapps] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e) => {
    setOpen(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/hypervisedvmcustomapplist/${OSTYPE}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setCustomapps(resp))
      .catch((error) => {
        console.error(error);
      });
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [selectedValue, setSelectedValue] = React.useState({});
  const [selectedPorts, setSelectedPorts] = React.useState({});
  const [selectedApps, setSelectedApps] = React.useState({});
  const [forversion, setForversion] = React.useState({});
  const [selectedVersions, setSelectedVersions] = React.useState({});
  const [searchItems, setSearchItems] = React.useState("");

  const handleCancel = () => {
    setOpen(false);
    // appsetFormFields((prevState) => ({
    //   ...prevState,
    //   [appfieldIndex]: null,
    // }));
    setSelectedValue([]);
    setForversion([]);
    setSelectedVersions([]);
    setSelectedApps([]);
    setSelectedPorts([]);
  };

  const handleChange = (e, index, ports) => {
    const { value, checked } = e.target;

    if (selectedValue[value]) {
      setSelectedValue((prevState) => ({
        ...prevState,
        [value]: false,
      }));
      if (ports !== null) {
        setSelectedPorts((prevState) => ({
          ...prevState,
          [ports]: false,
        }));
        setSelectedApps((prevState) => ({
          ...prevState,
          [ports]: "",
        }));
      }
      setForversion((prevState) => ({
        ...prevState,
        [index]: "",
      }));
      setSelectedVersions((prevState) => ({
        ...prevState,
        [value]: "",
      }));
    } else {
      setSelectedValue((prevState) => ({
        ...prevState,
        [value]: checked,
      }));
      if (ports !== null) {
        setSelectedPorts((prevState) => ({
          ...prevState,
          [ports]: true,
        }));
        setSelectedApps((prevState) => ({
          ...prevState,
          [ports]: value,
        }));
      }
      if (value) {
        const apipostval = value + "-" + OSTYPE;
        fetch(
          `${process.env.REACT_APP_API_URL}/api/hypervisedvmcustomversionlist/${apipostval}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
          .then((resp) => resp.json())
          .then((resp) =>
            setForversion((prevState) => ({
              ...prevState,
              [index]: resp,
            }))
          )
          .catch((error) => {
            console.error(error);
          });
      }
    }
  };

  const [blockapps, setBlockapps] = React.useState(false);
  const [apperror, setApperror] = React.useState(false);

  const handleChangeInput = (e, index, appname) => {
    const { value } = e.target;
    setSelectedVersions((prevState) => ({
      ...prevState,
      [appname]: value,
    }));
  };

  const handleSubmitClick = (e) => {
    let assignAppValue = [];
    let assignAppports = [];
    let count = 0;
    let version;
    customapps.forEach((appdata) => {
      if (selectedValue[appdata.Name]) {
        if (selectedVersions[appdata.Name]) {
          version = selectedVersions[appdata.Name];
          const appval = appdata.Name + version;
          assignAppValue.push(appval);
          assignAppports.push(appdata.Ports);
        } else {
          count = count + 1;
        }
      }
    });
    if (count > 0) {
      setApperror(true);
    } else {
      setApperror(false);
      appsetFormFields((prevState) => ({
        ...prevState,
        [appfieldIndex]: assignAppValue,
      }));
      setNormalport((prevState) => ({
        ...prevState,
        [appfieldIndex]: assignAppports,
      }));
      setOpen(false);
    }
  };

  return (
    <>
      <div>
        <Tooltip title="Select applications">
          <span>
            <Fab variant="extended" size="small" color="primary" aria-label="add" sx={{ borderRadius: '16px' }}>
              <Chip
                icon={<AddIcon />}
                label="Applications"
                clickable
                color="primary"
                onClick={handleClickOpen}
              />
            </Fab>
          </span>
        </Tooltip>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Applications </DialogTitle>
        {blockapps && (
          <Alert severity="warning">
            <AlertTitle>Warning</AlertTitle>
            Don't choose multiple applications with same port!
          </Alert>
        )}
        {apperror && (
          <Alert severity="warning">
            <AlertTitle>Warning</AlertTitle>
            Please make sure all the fields are selected.
          </Alert>
        )}
        <DialogContent dividers>
          <SearchField
            value={searchItems}
            placeholder="Search..."
            onChange={(value) => setSearchItems(value)}
            classNames="test-class"
          />
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            <Box>
              {customapps.length > 0 && (
                <>
                  <Grid container spacing={1}>
                    <Grid item xs={8}>
                      <Grid container spacing={0} sx={{ mt: 3 }}>
                        <Grid item xs={8}>
                          <Typography variant="h8" gutterBottom>
                            Application
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography variant="h8" gutterBottom>
                            Version
                          </Typography>
                        </Grid>
                      </Grid>
                      <Divider />
                      {customapps
                        .filter((val) => {
                          if (searchItems === "") {
                            return val;
                          } else if (
                            val.Title.toLowerCase().includes(
                              searchItems.toLowerCase()
                            )
                          ) {
                            return val;
                          }
                          return null;
                        })
                        .map((e, index) => {
                          let ports = e.Ports;
                          let appname = e.Name;
                          return (
                            <Grid container spacing={0} sx={{ mt: 3 }} key={index}>
                              <Grid item xs={8}>
                                <Checkbox
                                  checked={!!selectedValue[e.Name]}
                                  onChange={(e) =>
                                    handleChange(e, index, ports)
                                  }
                                  disabled={
                                    selectedApps[ports] !== e.Name &&
                                    selectedPorts[ports]
                                  }
                                  value={e.Name}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                />
                                <Typography variant="h8" gutterBottom>
                                  {`${e.Title}`}
                                </Typography>
                                <FormHelperText sx={{ ml: 5 }}>min req: {e.requirements}</FormHelperText>
                              </Grid>
                              <Grid item xs={2}>
                                <TextField
                                  fullWidth
                                  name={`version`}
                                  id={`version`}
                                  onChange={(e) =>
                                    handleChangeInput(e, index, appname)
                                  }
                                  required
                                  select
                                  SelectProps={{ native: true }}
                                  autoComplete="name"
                                  value={selectedVersions[appname] || ""}
                                  error={Boolean(apperror && selectedValue[e.Name] && !selectedVersions[appname])}
                                  helperText={apperror && selectedValue[e.Name] && !selectedVersions[appname] ? 'Version is required' : undefined}
                                >
                                  <option value="">
                                    --Select the Version--
                                  </option>
                                  {forversion[index] &&
                                    forversion[index]
                                      .split(",")
                                      .map((appdata, idx) => (
                                        <option value={appdata} key={idx}>
                                          {appdata}
                                        </option>
                                      ))}
                                </TextField>
                              </Grid>
                            </Grid>
                          );
                        })}
                    </Grid>
                    <Grid item xs={4}>
                      <Box
                        sx={{
                          fontStyle: "italic",
                          height: "100%",
                          backgroundColor: "whitesmoke",
                        }}
                        borderColor="error.main"
                        border={1}
                      >
                        <strong>Chosen Applications :</strong>
                        {customapps.map((e, index) => {
                          if (
                            selectedValue[e.Name] &&
                            !selectedVersions[e.Name]
                          ) {
                            return (
                              <li
                                key={index}
                                style={{ textAlignLast: "center" }}
                              >{`${e.Name}-<Version>`}</li>
                            );
                          } else if (
                            selectedValue[e.Name] &&
                            selectedVersions[e.Name]
                          ) {
                            return (
                              <li key={index} style={{ textAlignLast: "center" }}>{`${e.Name}-${selectedVersions[e.Name]}`}</li>
                            );
                          }
                          return null;
                        })}
                      </Box>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog">
            <span>
              <Button onClick={handleClose} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
                Close
              </Button>
            </span>
          </Tooltip>
          <Tooltip title="Cancel and discard changes">
            <span>
              <Button onClick={handleCancel} variant="contained" color="secondary" sx={{ borderRadius: '50px' }}>
                Cancel
              </Button>
            </span>
          </Tooltip>
          <Tooltip title="Save selected applications">
            <span>
              <Button onClick={handleSubmitClick} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
                Save
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
}
